import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { DataProvider } from './contexts/DataContext';

export default function AppWrapper() {
  return (
    <Router>
      <DataProvider>
        <App />
      </DataProvider>
    </Router>
  );
}
